// extracted by mini-css-extract-plugin
export default {"largeModal":"TreatmentResultRecordsModal_largeModal__scawA","modalBody":"TreatmentResultRecordsModal_modalBody__bjjpI"};